import React from "react";
import LeftMeetingComponent from "../../components/LeftMeeting";

const index = () => {
  return (
    <>
      <LeftMeetingComponent />
    </>
  );
};

export default index;
